// @flow
import { fetchCatalogsIfNeeded, getCatalog } from '../../../redux/modules/catalog';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchCatalogDetailsIfNeeded } from '../../../redux/modules/catalogDetail';
import { fetchCoverLotsIfNeeded } from '../../../redux/modules/coverLots';
import { fetchSellersIfNeeded } from '../../../redux/modules/seller';
import { getIdFromPath } from '../../../utils/urls';
import { recordAnalyticsForCatalogTermsPageView } from '../../../redux/modules/analytics';

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const { pathname } = location;
    const catalogId = getIdFromPath(pathname);
    return Promise.all([
        dispatch(fetchCatalogsIfNeeded([catalogId])),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCoverLotsIfNeeded([catalogId])),
        dispatch(recordAnalyticsForCatalogTermsPageView()),
    ]).then(() => {
        const state = getState();
        const catalog = getCatalog(state, catalogId);

        return Promise.all([
            dispatch(fetchSellersIfNeeded([catalog.sellerId])),
            dispatch(recordAnalyticsForCatalogTermsPageView()),
        ]);
    });
};
